import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DsModalService, DsModalVariant } from '@levelaccess/design-system';
import { VerticalNavigationModalComponent } from './vertical-navigation-modal/vertical-navigation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class VerticalNavigationStateService {
  private readonly _collapseRequests$: Subject<void> = new Subject<void>();
  public readonly collapseRequests$: Observable<void> = this._collapseRequests$.asObservable();

  constructor(private modalService: DsModalService) {}

  public openVerticalNavigationModal(): void {
    this.modalService.open(VerticalNavigationModalComponent, DsModalVariant.fullScreen);
  }

  public collapseNav(): void {
    this._collapseRequests$.next();
  }
}
